import { useContext } from "react";
import { FeatureSettingContext } from "../context/FeatureSettings";

const useFeatureSetting = () => useContext(FeatureSettingContext);
export default useFeatureSetting;
